export default __webpack_public_path__ + "static/media/success_sound.9fd5c4fa.wav";